import { FC, PropsWithChildren } from "react";

import Stack from "@mui/material/Stack";

import { DashboardInputLabel } from "@/dashboard-design-system/InputLabel/DashboardInputLabel";

interface TranslationEditorFieldProps {
  label: string;
  name: string;
}

export const TranslationEditorField: FC<PropsWithChildren<TranslationEditorFieldProps>> = ({
  label,
  name,
  children,
}) => (
  <DashboardInputLabel label={label} slotProps={{ labelTypography: { id: `${name}-label` } }}>
    <Stack
      role="group"
      aria-labelledby={`${name}-label`}
      sx={(theme) => ({
        minWidth: 0,
        "& > .MuiGrid-root": {
          borderColor: theme.palette.border.neutral.quiet,
          borderRadius: theme.radius(1),
          backgroundColor: theme.palette.surface.neutral.white,
        },
      })}
    >
      {children}
    </Stack>
  </DashboardInputLabel>
);
